import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-tabs', 'selectTab', 'Выбрать вкладку');
Labels.set('ui-tabs', 'left', 'Перейти влево');
Labels.set('ui-tabs', 'right', 'Перейти вправо');
